// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M10.5 10.5L14.5 10.5L14.5 14.5M14 10.5C13.02 12.85 10.7 14.5 8 14.5C4.41 14.5 1.5 11.59 1.5 8C1.5 4.41 4.41 1.5 8 1.5C10.89 1.5 13.34 3.39 14.19 6',
];
